export function session_get_adom(state) {
  // keep it same as: getAdom
  // in file: static/js/fistore/sysConfig/service/index.js
  // do not import from it will cause circular dep issue
  return state.session.adom.data || {};
}
